import '@babel/polyfill';
import React, { Component } from 'react';
import { withCookies } from 'react-cookie';
import {
    Route,
    Routes,
    BrowserRouter as Router,
} from 'react-router-dom';
import './App.css';
import Header from './menu/Header';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { theme } from '../assets/theme';
import Chat from './line/Chat';
import SignIn from './login/SignIn';
import QR from './qr/Qr';
import Category from './category/Category';
import Message from './selectUser/Message';
import MessageLog from './messageLog/MessageLog';
import Notification from './notification/Notification';
// import Counseling from "./line/Counseling";

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <MuiThemeProvider theme={theme}>
                <div className="App">
                    <Header />
                    <Router>
                        <Routes>
                            <Route exact path='/' element={<SignIn />} />
                            <Route exact path='/qr' element={<QR />} />
                            <Route exact path='/category' element={<Category />} />
                            <Route exact path='/chat' element={<Chat />} />
                            <Route exact path='/message' element={<Message />} />
                            <Route exact path='/message/sent' element={<MessageLog />} />
                            <Route exact path='/setting' element={<Notification />} />
                        </Routes>
                    </Router>
                </div>
            </MuiThemeProvider>
        );
    }
}

//値の検証
App.propTypes = {
    //   classes: PropTypes.object.isRequired,
};

export default withCookies(App);
